import { FunctionComponent } from 'react';
import { Box, xcss } from '@atlaskit/primitives';

import { defineMessages, FormattedMessage } from 'react-intl';

const centeredContentStyles = xcss({
  textAlign: 'center',
});

const messages = defineMessages({
  title: {
    id: 'heading',
    defaultMessage: '{appName} would like access to your Atlassian account',
    description: 'Heading for oauth',
  },
});

type HeaderProps = {
  appName: string;
};

const Header: FunctionComponent<HeaderProps> = ({ appName }) => (
  <Box xcss={centeredContentStyles}>
    <FormattedMessage {...messages.title} tagName="h1" values={{ appName }} />
  </Box>
);

export default Header;
